// import package
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons/faUserAlt";

// import component
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";

// import action
import { logoutUser } from "../../actions/authActions";
import { getDashboardDet } from '../../actions/dashboardAction';

class Dashboard extends Component {

    constructor() {
        super()
        this.state = {
            records: '',
            countResult: {}
        }
    }

    onLogoutClick = e => {
        e.preventDefault();
        this.props.logoutUser();
    };

    async fetchDashboardDet() {
        let { status, result } = await getDashboardDet()
        if (status) {
            this.setState({ countResult: result })
        }
    }

    componentDidMount() {
        this.fetchDashboardDet();
    }

    render() {
        const { countResult } = this.state

        return (
            <div>
                <Navbar />
                <div className="d-flex" id="wrapper">
                    <Sidebar />
                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            <h3 className="mt-2 text-secondary">Dashboard </h3>
                            <div className="row px-0 px-md-2">

                                <div className="col-sm-3 p-sm-2 mb-4 mb-sm-0">
                                    <div className="card text-white shadow-lg" style={{ backgroundColor: "cornflowerblue" }}>
                                        <div className="card-body">
                                            <h5 className="card-title">Partners </h5>
                                            <p className="card-text">Total Number of Partners - {countResult && countResult.partnerCnt}</p>
                                            <Link to="/partners" className="btn btn-light"><FontAwesomeIcon className="text-primary mr-1" icon={faUserAlt} /> Go to Partners</Link>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-sm-3 p-sm-2 mb-4 mb-sm-0">
                                    <div className="card text-white shadow-lg" style={{ backgroundColor: "cadetblue" }}>
                                        <div className="card-body">
                                            <h5 className="card-title">Accounts</h5>
                                            <p className="card-text"> Total Number of Accounts - {countResult && countResult.accountCnt}</p>
                                            <Link to="/accounts" className="btn btn-light"><FontAwesomeIcon className="text-primary mr-1" icon={faUserAlt} /> Go to Accounts</Link>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Dashboard.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(
    mapStateToProps,
    { logoutUser }
)(Dashboard);
